import React, {useCallback} from 'react';

import {useI18n} from '../../../../../../../data/hooks/i18nHooks';
import ContainedImage from '../../../../../../elements/ContainedImage';
import icon from '../../../icons/icon-user.png';
import styles from '../BubbleMenu.module.scss';

const Profile = props => {
    const {event, user} = props,
        i18n = useI18n();

    const handleOpenProfile = useCallback(() => {
        if ((event, user)) {
            const url = ['/events', event.id, 'participants', user.user_id || '-', user.participant_id || '-'].join('/');
            app.history.push(url);
        }
    }, [event, user]);

    return (
        <button type="button" onClick={handleOpenProfile}>
            <span className={styles.label}>{i18n['label.contact.information']}</span>
            <ContainedImage src={icon} color="white" />
        </button>
    );
};

export default Profile;
